module.exports = require('./helpers/bundle-url').getBundleURL('hcTqB') + "mobileEmailFooter.8902b992.jpg";